export const programSections = [
    {
        title: "Программы", // Заголовок верхнего уровня
        type: "category", // Добавим тип для дифференциации
        subItems: [ // Теперь это массив под-элементов/подкатегорий
            {
                title: "Профильная",
                description: "Санаторий специализируется на бережном восстановлении здоровья, уделяя особое внимание укреплению сердечно-сосудистой и дыхательной систем, а также гармонизации функциональных состояний нервной системы.",
                imageUrl: "/Assets/Programs/1.jpg",
            },
            {
                title: "Здоровое сердце",
                description: "Программы лечения разработаны для эффективной профилактики и бережной терапии заболеваний сердечно-сосудистой системы. Мы уделяем особое внимание устранению синдрома вегетативной дисфункции и полному восстановлению жизненно важной работоспособности вашего сердца, возвращая ему силу и ритм",
                imageUrl: "/Assets/Programs/2.jpg",
            },
            {
                title: "Легкое дыхание",
                description: "Лечебные программы направлены на эффективное облегчение состояния и устранение хронических воспалительных процессов в ЛОР-органах, а также в верхних и нижних дыхательных путях, возвращая вам легкость и свободу каждого вдоха.",
                imageUrl: "/Assets/Programs/3.jpg",
            },
            {
                title: "Гармония души",
                description: "Лечебные программы направлены на восстановление внутреннего спокойствия и гармонии при хронических функциональных расстройствах нервной системы, возвращая вам ощущение легкости и контроля над собственным состоянием.",
                imageUrl: "/Assets/Programs/4.jpg",
            },
            {
                title: "Мужское здоровье",
                description: "Специалисты уделяют первостепенное внимание ранней диагностике и своевременному выявлению урологических заболеваний, что является залогом успешного лечения и сохранения вашего здоровья на долгие годы.",
                imageUrl: "/Assets/Programs/5.jpg",
            },
            {
                title: "Женское здоровье",
                description: "Лечебные программы направлены на бережное восстановление и укрепление женского здоровья, обеспечивая эффективное лечение хронических воспалительных заболеваний половых органов для вашего полного благополучия и комфорта.",
                imageUrl: "/Assets/Programs/6.jpg",
            },
            {
                title: "Здоровые суставы",
                description: "Лечебные программы направлены на восстановление легкости движений и комфорта в каждом шаге. Мы специализируемся на эффективной терапии заболеваний опорно-двигательного аппарата, включая артрозы, артриты и хронические состояния позвоночника, возвращая вам радость активной жизни.",
                imageUrl: "/Assets/Programs/7.jpg",
            },
            {
                title: "Кладовая жизненных сил",
                description: "Программы лечения созданы для тех, кто чувствует ослабление иммунной системы, страдает от нервного и психоэмоционального напряжения, а также синдрома хронической усталости. Мы поможем вам восстановить внутренние ресурсы, обрести спокойствие и вновь почувствовать прилив жизненных сил.",
                imageUrl: "/Assets/Programs/8.jpg",
            },
        ]
    },
];